/**
 * The student / public-facing tenant storefront. See admin-storefront for
 * the management screen.
 */

import { FixedPage } from '@course/components/fixed-page';
import { ErrorPage } from '@components/error-page';
import { BlockViewer, ErrHandler } from '@course/components/page-builder';
import { CourseBlockContext, load } from '../admin-storefront/types';
import { blockDefinitions } from '../admin-storefront/block-definitions';
import { useCurrentUser } from '@components/router/session-context';
import { LoadedProps } from '@components/router';
import { defStudentRoute } from '@course/components/courses-app-router';

export const route = defStudentRoute({
  isPublic: true,
  Page,
  load,
});

export function Page({ state, setState }: LoadedProps<typeof load>) {
  const { content } = state.builderState;
  const currentUser = useCurrentUser();
  const canEdit = currentUser?.level === 'admin' || currentUser?.level === 'superadmin';

  if (!content?.blockIds.length) {
    return <ErrorPage title="404 | Not found" />;
  }

  return (
    <FixedPage title="Store">
      <CourseBlockContext.Provider value={{ state, setState }}>
        <div class="@container flex grow flex-col bg-white sales-page text-base text-gray-700">
          {content.blockIds.map((id) => {
            const blockState = content.blocks[id];
            const definition = blockDefinitions[blockState.type];
            return (
              <ErrHandler key={id}>
                <BlockViewer definition={definition} state={blockState} />
              </ErrHandler>
            );
          })}
        </div>
        {canEdit && (
          <a class="btn fixed top-8 right-8 bg-white shadow-lg" href="/admin/store">
            Edit Storefront
          </a>
        )}
      </CourseBlockContext.Provider>
    </FixedPage>
  );
}
